export class ProcessoImportacao {
    mensagem: string;
    erro: boolean;
    numero: string;

    constructor(mensagem, erro, numero) {
        this.mensagem = mensagem;
        this.erro = erro;
        this.numero = numero;
    }

}